<template>
    <div v-if="authStore.$state.user.isAdmin" class="relative mr-4">
        <div class="flex items-center px-2 py-1">
            <!-- Store Icon -->
            <div class="flex items-center justify-center mr-2">
                <i class="fas fa-store text-white/80 text-sm"></i>
            </div>

            <!-- Location Info -->
            <div class="flex flex-col min-w-0">
                <AppSelect
                    v-model="selectedLocation"
                    :options="availableLocations"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Sélectionner..."
                    :disabled="isLoading"
                    @change="handleLocationChange"
                />
            </div>

            <!-- Loading Spinner -->
            <div v-if="isLoading" class="ml-2 flex items-center">
                <i class="fas fa-spinner fa-spin text-white/70 text-xs"></i>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useApiStore } from '@/js/stores/apiStore.js';
import { useAuthStore } from '@/js/stores/authStore.js';
import { usePopupStore } from '@/js/stores/popupStore.js';
import { onMounted, ref } from 'vue';

const authStore = useAuthStore();
const apiStore = useApiStore();
const popupStore = usePopupStore();

const isLoading = ref(false);
const availableLocations = ref([]);

const selectedLocation = authStore.$state.user.currentStockLocation;

const handleLocationChange = async event => {
    const locationId = event.value;
    if (isLoading.value || selectedLocation.value === locationId) return;

    isLoading.value = true;

    try {
        await apiStore.apiPost('/api/stock-location/change', {
            stock_location: locationId,
        });

        // Find the location object to get the name
        const location = availableLocations.value.find(
            loc => loc.id === locationId,
        );

        // Update the user's current stock location in the store
        authStore.$state.user.currentStockLocation = locationId;
        authStore.$state.user.currentStockLocationName =
            location?.name || 'Liège';

        // Show success notification
        popupStore.show(
            'success',
            `Stock changé vers ${location?.name || 'Liège'}`,
        );

        // Emit an event to refresh data
        window.dispatchEvent(
            new CustomEvent('stock-location-changed', {
                detail: { location: locationId },
            }),
        );
    } catch (error) {
        console.error('Error changing stock location:', error);
        popupStore.show('warning', 'Erreur lors du changement de stock');
    } finally {
        isLoading.value = false;
    }
};

const loadAvailableLocations = async () => {
    try {
        const response = await apiStore.apiGet('/api/stock-location/available');

        availableLocations.value = response.locations || [];
    } catch (error) {
        console.error('Error loading available locations:', error);
    }
};

onMounted(() => {
    loadAvailableLocations();
});
</script>

<style>
/* Global styles for dropdown items - very generic selectors */
.p-dropdown-panel li {
    color: #374151 !important;
    background: white !important;
    padding: 12px 16px !important;
    font-size: 14px !important;
    cursor: pointer !important;
    border: none !important;
    transition: background-color 0.15s ease-in-out !important;
}

.p-dropdown-panel li:hover {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
}

.p-dropdown-panel div {
    color: #374151 !important;
    background: white !important;
}

.p-dropdown-panel div:hover {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
}

/* Target any child elements */
.p-dropdown-panel * {
    color: #374151 !important;
}
</style>
